module.exports = __webpack_public_path__ + "assets/trash.40d25758.svg";